import { Box, Grid, GridItem, Heading, Icon, Link, Text, useMediaQuery } from "@chakra-ui/react"
import useDates from "../../../hooks/useDates"
import LoadingIndicator from "components/ui/LoadingIndicator"
import React from "react"
import Slider from "react-slick"
import { CalendarIcon } from "components/graphics/calendarIcon"
import { FiChevronLeft, FiChevronRight } from "react-icons/fi"

const fontKallisto = {
    fontFamily: "kallisto, sans-serif",
}
const headerStyles = {
    fontSize: "32px !important",
    lineHeight: "36px !important",
}

const slickArrowStyles = {
    fontSize: "0",
    lineHeight: "0",
    position: "absolute",
    top: "50%",
    display: "block",
    padding: "0",
    transform: "translate(0, -50%)",
    cursor: "pointer",
    color: "transparent",
    border: "none",
    outline: "none",
    background: "transparent",
}

export default function Cto2026KeyDates({ block }) {
    const { status, dateGroups } = useDates("keyDates")
    const jsonObj = block?.json ? JSON.parse(block.json) : {}
    const lightMode = jsonObj.lightMode ? true : false

    if (status !== "success") return <LoadingIndicator />

    const SampleNextArrow = props => {
        const { currentSlide, className, onClick } = props
        //dataGroups[0].dataItems.length - 1
        // if (currentSlide === dateGroups[0].dateItems.length - 1) {
        if (className === "slick-arrow slick-next slick-disabled") {
            return false
        } else {
            return (
                <Box
                    {...slickArrowStyles}
                    right={["-60px", "-60px", "-60px"]}
                    _before={{
                        content: '""',
                    }}
                    width={"60px"}
                    height={"60px"}
                    zIndex={"999"}
                    onClick={onClick}
                >
                    <Icon
                        as={FiChevronRight}
                        style={lightMode ? { stroke: "#3474e4" } : { stroke: "#FFFFFF" }}
                        w="100%"
                        h="100%"
                    />
                </Box>
            )
        }
    }

    const SamplePrevArrow = props => {
        const { currentSlide, className, onClick } = props
        if (currentSlide === 0) {
            return false
        } else {
            return (
                <Box
                    {...slickArrowStyles}
                    left={["-60px", "-60px", "-60px"]}
                    _before={{
                        content: '""',
                    }}
                    width={"60px"}
                    height={"60px"}
                    zIndex={"9999"}
                    onClick={onClick}
                >
                    <Icon
                        as={FiChevronLeft}
                        style={lightMode ? { stroke: "#3474e4" } : { stroke: "#FFFFFF" }}
                        w="100%"
                        h="100%"
                    />
                </Box>
            )
        }
    }
    const keyDatesSlideSettings = {
        infinite: false,
        speed: 1000,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: false,

        //adaptiveHeight: true,
        // vertical: true,
        // verticalSwiping: true,
        //verticalSwiping: true,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    //vertical: true,
                    infinite: false,
                    swiping: true,
                    //verticalSwiping: true,
                },
            },
        ],

        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        arrows: true,
        dots: false,
    }

    const DatesToKnowSlider = ({ data }) => {
        const [mobile] = useMediaQuery("(max-width: 600px)")
        const [mobile2] = useMediaQuery("(max-width: 1300px)")

        return (
            <Box p={"0px 60px"}>
                <Slider
                    className={"keyDates"}
                    width={["100%"]}
                    //border={"solid thin green"}
                    {...keyDatesSlideSettings}
                    margin={["0px", "0px", "0px", "0px 0px"]}
                    padding={"0px 30px"}
                >
                    {data.map((slide, i) => {
                        //console.log("slide:", slide)
                        const date = slide.text
                        const desc = slide.text2
                        const addEvent = slide.addEventLink ? slide.addEventLink : false
                        return (
                            <Box key={i}>
                                <Box
                                    className={"Box"}
                                    backgroundColor={"white"}
                                    flexDirection={"column"}
                                    justifyContent={"space-between"}
                                    gap={"20px"}
                                    display={"flex !important"}
                                    padding={"10px 5px"}
                                    borderRadius={"20px"}
                                    height={mobile ? "270px" : mobile2 ? "350px" : "290px"}
                                    border={lightMode ? "solid 2px #85ACF1" : "none"}
                                >
                                    <Box>
                                        <Box
                                            css={{
                                                "& h2": {
                                                    mb: "20px",
                                                    color: slide.isActive ? "#e30031  !important" : "gray !important",
                                                    textTransform: "uppercase",
                                                    textAlign: "center",
                                                    fontFamily: "canada-type-gibson, Arial",
                                                    fontSize: "26px !important",
                                                    padding: "0px 8px",
                                                },
                                            }}
                                            dangerouslySetInnerHTML={{
                                                __html: date,
                                            }}
                                        ></Box>

                                        <Box
                                            color={"black"}
                                            textAlign={"center"}
                                            fontSize={"16px !important"}
                                            lineHeight={"18px"}
                                            padding={"0px 15px"}
                                            dangerouslySetInnerHTML={{
                                                __html: desc,
                                            }}
                                            height={"40px"}
                                            css={{
                                                "& p": {
                                                    fontSize: "16px !important",
                                                    lineHeight: "18px",
                                                },
                                            }}
                                        />
                                    </Box>

                                    <Box display={"flex"} justifyContent={"center"} mb={"10px"}>
                                        {addEvent ? (
                                            <Box
                                                maxWidth={"52px"}
                                                flex={"1 1 2%"}
                                                p={"10px"}
                                                justifyContent={"center"}
                                                alignItems={"flex-start"}
                                                backgroundColor={"#81adf8"}
                                                borderRadius={"50%"}
                                                display={slide.addEventLink ? "block" : "none"}
                                            >
                                                <Link
                                                    href={addEvent}
                                                    target={"_blank"}
                                                    cursor={"pointer"}
                                                    display={"flex"}
                                                >
                                                    <CalendarIcon
                                                        color={"white !important"}
                                                        fill={"white !important"}
                                                        fontWeight={600}
                                                        fontSize={"30px"}
                                                        mr={"0px"}
                                                        ml={"2px"}
                                                        mt={"2px"}
                                                        width={"30px"}
                                                        height={"30px"}
                                                        _hover={{
                                                            color: "white !important",
                                                        }}
                                                    />
                                                </Link>{" "}
                                            </Box>
                                        ) : (
                                            <Box maxWidth={"52px"} flex={"1 1 2%"} p={"10px"}>
                                                <Box width={"30px"} height={"30px"}></Box>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </Box>
                        )
                    })}
                </Slider>
            </Box>
        )
    }

    return (
        <Grid
            width={"100%"}
            templateColumns={`1fr 1fr 1fr`}
            templateRows={`1fr`}
            background={lightMode ? "white" : "linear-gradient(90deg, #0f2072,  #1b5cd4);"}
            className={`Cto2026KeyDates ${block.customClass ? block.customClass : ""}`}
        >
            <GridItem
                zIndex={"10"}
                gridColumnStart={1}
                gridColumnEnd={4}
                gridRowStart={1}
                gridRowEnd={2}
                padding={"50px 0px"}
            >
                <Heading
                    {...fontKallisto}
                    textAlign={"center"}
                    mt={"0px"}
                    mb={"30px"}
                    as={"h1"}
                    color={"white !important"}
                    {...headerStyles}
                    className={"font-gothics bg-dots"}
                >
                    <img src="https://assets.crfconnect.com/meetings/cto2026/page-content/cto_header_dotted_line_left.png" />

                    <Text as={"span"} fontSize={"42px"} color={lightMode ? "#1E64E1" : "white"}>
                        {dateGroups[0].title}
                    </Text>
                    <img src="https://assets.crfconnect.com/meetings/cto2026/page-content/cto_header_dotted_line_right1.png" />
                </Heading>
                <DatesToKnowSlider data={dateGroups[0].dateItems} />
            </GridItem>
            <GridItem
                zIndex={"1"}
                gridColumnStart={1}
                gridColumnEnd={4}
                gridRowStart={1}
                gridRowEnd={5}
                mixBlendMode={"overlay"}
                //backgroundImage={"https://assets.crfconnect.com/meetings/tct2025/homepage/tct2025_rounded_shapes1.png"}
                backgroundRepeat={"no-repeat"}
                backgroundPosition={"bottom right"}
                opacity={".3"}
                backgroundSize={`${1273 * 0.7}px ${177 * 0.7}px`}
            ></GridItem>
        </Grid>
    )
}
